import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { OnlineOrderPayload, ProceedPaymentResponse, razorPayProcessI } from "../Interface/Payment.interface";
import { confirmPayment, fetchPaymentData, SavePayment } from "../Action/payment.Action";


interface PaymentState {
  loading: boolean;
  data: ProceedPaymentResponse | null;
  error: string | null;
  confirmStatus: "idle" | "loading" | "success" | "error";
  confirmResponse: any | null;
  confirmOrder: "idle" | "loading" | "success" | "error";
  saveOrderResponse:any| null
}



const initialState: PaymentState = {
  loading: false,
  data: null,
  error: null,
  confirmStatus: "idle",
  confirmResponse: null,
  confirmOrder:'idle',
  saveOrderResponse:null
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    clearPaymentState: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
      state.confirmStatus = "idle";
      state.confirmResponse = null;
    }
  },
  extraReducers: (builder) => {
    // Initiate Payment
    builder
      .addCase(fetchPaymentData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentData.fulfilled, (state, action: PayloadAction<ProceedPaymentResponse>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPaymentData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch payment data";
      });

    // Confirm Payment
    builder
      .addCase(confirmPayment.pending, (state) => {
        state.confirmStatus = "loading";
      })
      .addCase(confirmPayment.fulfilled, (state, action: PayloadAction<razorPayProcessI>) => {
        state.confirmStatus = "success";
        state.confirmResponse = action.payload;
      })
      .addCase(confirmPayment.rejected, (state, action) => {
        state.confirmStatus = "error";
        state.error = action.payload || "Failed to confirm payment";
      });


    //saveorder 

    builder
      .addCase(SavePayment.pending, (state) => {
        state.confirmOrder = "loading";
      })
      .addCase(SavePayment.fulfilled, (state, action: PayloadAction<OnlineOrderPayload>) => {
        state.confirmOrder = "success";
        state.confirmResponse = action.payload;
      })
      .addCase(SavePayment.rejected, (state, action) => {
        state.confirmOrder = "error";
        state.confirmResponse = action.payload || "Failed to confirm payment";
      });
  }
});

export const { clearPaymentState } = paymentSlice.actions;
export default paymentSlice.reducer;
